const pendingScripts = new Map<string, Promise<void>>()

export function loadScriptOnce(src: string): Promise<void> {
  const existing = pendingScripts.get(src)
  if (existing) return existing

  const loading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => {
      pendingScripts.delete(src)
      script.remove()
      reject(new Error(`Failed to load ${src}`))
    }
    document.head.appendChild(script)
  })
  pendingScripts.set(src, loading)
  return loading
}
